import styled from "styled-components";

export const FiltrosContainer = styled.div`
  align-items: center;
  justify-content: flex-start;
  margin: 20px auto;
  span {
    color: #444444;
    font-weight: bold;
    font-size: 12px;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    margin-bottom: 16px;
  }
`;

export const BotoesContainer = styled.div`
  display: block;
  margin-top: 8px;
  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: repeat(3, 33.33%);
    margin-left: 0px;
  }
`;

export const BotaoFiltro = styled.button`
  background-color: transparent;
  border: none;
  width: 20%;
  font-size: 12px;
  height: 30px;
  border-bottom: ${(props) => (props.active ? `2px solid red` : "none")};
  color: ${(props) => (props.active ? `2px solid red` : "none")};
  font-weight: bold;
  font-size: 12px;
  transition: 0.3;
  cursor: pointer;
  @media (max-width: 768px) {
    margin: 4px;
    width: auto;
  }
`;
